// Default list view dimensions, this should be greater or equal to the minimum list view dimensions
export const DEFAULT_LIST_VIEW_WIDTH: number = 350;
export const DEFAULT_LIST_VIEW_HEIGHT: number = 270;

export const MIN_LV_WIDTH_WITH_FULL_HEADER_BUTTONS: number = 625;

export const RPRIGHT_RECEIVED_COLUMN_CONTENT_MIN_WIDTH: number = 104;

export const RPFULL_RECEIVED_COLUMN_CONTENT_MIN_WIDTH: number = 84;

// This constant should stay in sync with mailListItemRPRightPadding in ListViewItemCommonStyles.scss and
export const MCL_RPRIGHT_LIST_ITEM_RIGHT_PADDING: number = 8;

// This constant should stay in sync with mailListItemRightPadding in ListViewItemCommonStyles.scss and
export const MCL_LIST_ITEM_RIGHT_PADDING: number = 16;

export const RECEIVED_COLUMN_LEFT_PADDING: number = 8;

export const LV_SCROLLBAR_WIDTH: number = 16;

export const LV_RPRIGHT_RECEIVED_ADJUSTMENT: number =
    LV_SCROLLBAR_WIDTH + RECEIVED_COLUMN_LEFT_PADDING + MCL_RPRIGHT_LIST_ITEM_RIGHT_PADDING;

export const LV_RPFULL_RECEIVED_ADJUSTMENT: number =
    LV_SCROLLBAR_WIDTH + RECEIVED_COLUMN_LEFT_PADDING + MCL_LIST_ITEM_RIGHT_PADDING;

export const LV_RPRIGHT_RECEIVED_TOTAL_MIN_WIDTH: number =
    RPRIGHT_RECEIVED_COLUMN_CONTENT_MIN_WIDTH +
    RECEIVED_COLUMN_LEFT_PADDING +
    MCL_RPRIGHT_LIST_ITEM_RIGHT_PADDING;

export const LV_RPFULL_RECEIVED_TOTAL_MIN_WIDTH: number =
    RPFULL_RECEIVED_COLUMN_CONTENT_MIN_WIDTH +
    RECEIVED_COLUMN_LEFT_PADDING +
    MCL_LIST_ITEM_RIGHT_PADDING;

export const MCL_UNREAD_BAR_WIDTH: number = 4;
export const MCL_TWISTY_PERSONA_WIDTH: number = 62; // This should be in sync with the width of the twisty persona in ListViewItemPersonaStyles.scss

export const DEFAULT_CF_PREVIEW_SENDER_COLUMN_WIDTH: number = 30; // percentage
export const DEFAULT_CF_PREVIEW_SUBJECT_COLUMN_WIDTH: number = 56; // percentage
export const DEFAULT_CF_PREVIEW_RECEIVED_COLUMN_WIDTH: number = 14; // percentage
